export const TOKEN = 'access_token';
export const REFRESH = 'refresh_token';
export const PREFIX = '@triptango';
export const APP_NAME = 'TripTango';
